import React from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox,
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
  Delete,
  DoDisturbAlt,
  ExitToApp,
  ShareOutlined,
  Storefront,
  Twitter,
  Upload,
  WarehouseOutlined,
} from "@mui/icons-material";
import {
  delete_item_image,
  get_inventory_detail,
  get_upload_file,
  on_hold_listing,
  replace_image,
  upload_item_images,
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import toast from "react-simple-toasts";
import useUser from "../../hooks/useUser";

export default function InventoryDetail() {
  const classes = useStyles();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const { set_user, get_user } = useUser();

  const [searchKey, setSearchKey] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [openVariantImg, setOpenVariantImg] = React.useState(false);
  const [selectedVariant, setSelectedVariant] = React.useState(null);
  const [priceData, setPriceData] = React.useState(null);
  const [productImage, setProductImage] = React.useState("");
  const [infiniteStatus, setInfiniteStatus] = React.useState(true);
  const [holdingList, setHoldingList] = React.useState(null);
  const [openHolding, setOpenHolding] = React.useState(false);

  const settings = {
    dots: true,
    // infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
  };

  const handleSearch = (event) => {
    setSearchKey(event.target.value);
  };

  const [loading, setLoading] = React.useState(false);
  const [inventoryDetail, setInventoryDetail] = React.useState(null);
  const [inventoryDetail2, setInventoryDetail2] = React.useState([]);

  const getData = () => {
    setLoading(true);
    get_inventory_detail({
      item_id: params.item_id,
      // sort: sort
    }).then((json) => {
      setLoading(false);
      console.log(json.data.images.length < 5);
      setInventoryDetail(json.data);
      setInventoryDetail2(json.data.children);
      setProductImage(json.data.image);
      if (json.data.images.length < 5) {
        setInfiniteStatus(false);
      } else {
        setInfiniteStatus(true);
      }
    });
  };
  React.useEffect(() => {
    getData();
  }, []);

  const handleOpen = (e) => {
    setOpen(true);
    setPriceData(e);
  };
  const handleClose = (value) => {
    setOpen(false);
  };

  const handleOpenVariantImage = (e) => {
    if (e.images.length == 0) {
      toast("No image yet");
      return;
    }
    setOpenVariantImg(true);
    setSelectedVariant(e);
  };
  const handleCloseVariantImage = (value) => {
    setOpenVariantImg(false);
    setSelectedVariant(null);
  };

  const handleDeleteImage = async (e, index) => {
    if (window.confirm("Are you sure you want to delete this image?")) {
      delete_item_image({ item_image_id: e.item_image_id }).then((json) => {
        // setLoadingAdd(true);
        if (json.status) {
          // setLoadingAdd(false);
          toast("Image Deleted");
          getData();
          handleCloseVariantImage();
        } else {
          // setLoadingAdd(false);
          // toast(res.messege)
        }
      });
    }
  };

  const handleCaptureSingle = async (e, index) => {
    var formData = new FormData();
    // var token = window.localStorage.getItem("token");
    // formData.append("token", token);
    formData.append("image", e.target.files[0]);
    // setisLoading(true);
    var res = await get_upload_file(formData);
    console.log(res);
    if (res.data.status) {
      setProductImage(res.data.data);
    } else {
      toast(res.data.message);
    }
  };

  const handleCaptureMultiple = async (e, index) => {
    var formData = new FormData();

    formData.append("image_length", e.target.files.length);
    for (var i = 0; i < e.target.files.length; i++) {
      console.log(e.target.files[i]);
      formData.append("images_" + i, e.target.files[i]);
    }
    upload_item_images(formData).then((res) => {
      // setisLoadingModal(false)
      // console.log('res', res);
      if (res.status) {
        // var img = [...images];
        // for (var i = 0; i < res.data.length; i++) {
        //     console.log("OK " + i);
        //     img.push(res.data[i]);
        // }
        // setImages(img);
        getData();
        toast("Image Uploaded");
      }
    });

    console.log(formData);
  };

  const handleSaveImage = async () => {
    replace_image({
      item_id: params.item_id,
      image: productImage,
    }).then((json) => {
      toast("Image Replaced");
    });
  };

  const handleOpenHolding = () => {
    setOpenHolding(true);
  };

  const handleCloseHolding = () => {
    setOpenHolding(false);
  };

  const getHoldingList = (e) => {
    setLoading(true);
    on_hold_listing({ internalid: e }).then((resRep) => {
      setHoldingList(resRep.data);
      setLoading(false);
      handleOpenHolding();
    });
  };

  const filteredRows = inventoryDetail2.filter(
    (row) =>
      row.colorname.toLowerCase().includes(searchKey.toLowerCase()) ||
      row.itemname.toLowerCase().includes(searchKey.toLowerCase())
  );

  filteredRows.sort((a, b) => a.colorname.localeCompare(b.colorname));

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: "auto" }}>
          <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
        </div>
      ) : (
        <React.Fragment>
          {inventoryDetail != null && (
            <Navbar2
              children={
                <Section pd="2rem">
                  <div>
                    <div
                      onClick={() => navigate(-1)}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <Paragraph
                        color="#1A5386"
                        bold="400"
                        size="12px"
                        margin="0 0 1rem"
                      >
                        &lt; Back
                      </Paragraph>
                    </div>
                    <div className={classes.theFlexHeader}>
                      <Paragraph color="#1A5386" bold="600" size="24px">
                        {inventoryDetail.displayname}
                      </Paragraph>

                      {/* <div className={classes.theFlexBtn} style={{ marginBottom: "0" }}>
                                                <a
                                                    className={classes.theCustomActionBtnFill}
                                                // onClick={() => handleOpenStockMove()}
                                                >
                                                    <CheckCircleOutline sx={{ color: "#fff" }} />
                                                    <Paragraph margin="0 0 0 .4rem">Approve</Paragraph>
                                                </a>
                                                <a
                                                    className={classes.theCustomActionBtnFill_}
                                                // onClick={() => handleOpenStockMove()}
                                                >
                                                    <DoDisturbAlt sx={{ color: "#fff" }} />
                                                    <Paragraph margin="0 0 0 .4rem">Reject</Paragraph>
                                                </a>
                                            </div> */}
                    </div>
                    <div
                      style={{
                        borderBottom: "2px solid #707070",
                        padding: ".2rem 0",
                      }}
                    />
                    <br />

                    <Paragraph color="#000" bold="700" size="16px">
                      General Information
                    </Paragraph>
                    <br />
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12} md={6}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={4} md={4}>
                            <Paragraph size="14px">Product Type:</Paragraph>
                          </Grid>
                          <Grid item xs={12} sm={8} md={8}>
                            <Paragraph size="14px" bold="600">
                              {inventoryDetail.itemtype != "" &&
                              inventoryDetail.itemtype != null
                                ? inventoryDetail.itemtype
                                : "-"}
                            </Paragraph>
                          </Grid>
                          <Grid item xs={12} sm={4} md={4}>
                            <Paragraph size="14px">Product Brand:</Paragraph>
                          </Grid>
                          <Grid item xs={12} sm={8} md={8}>
                            <Paragraph size="14px" bold="600">
                              {inventoryDetail.brand != "" &&
                              inventoryDetail.brand != null
                                ? inventoryDetail.brand
                                : "-"}
                            </Paragraph>
                          </Grid>
                          <Grid item xs={12} sm={4} md={4}>
                            <Paragraph size="14px">
                              Product Sales Description:
                            </Paragraph>
                          </Grid>
                          <Grid item xs={12} sm={8} md={8}>
                            <Paragraph size="14px" bold="600">
                              {inventoryDetail.salesdescription != "" &&
                              inventoryDetail.salesdescription != null
                                ? inventoryDetail.salesdescription
                                : "-"}
                            </Paragraph>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={4} md={4}>
                            <Paragraph size="14px">
                              Quantity Available:
                            </Paragraph>
                          </Grid>
                          <Grid item xs={12} sm={8} md={8}>
                            <Paragraph size="14px" bold="600">
                              {inventoryDetail.quantityavailable != "" &&
                              inventoryDetail.quantityavailable != null
                                ? inventoryDetail.quantityavailable
                                : "-"}
                            </Paragraph>
                          </Grid>
                          <Grid item xs={12} sm={4} md={4}>
                            <Paragraph size="14px">
                              Product Sale Unit:
                            </Paragraph>
                          </Grid>
                          <Grid item xs={12} sm={8} md={8}>
                            <Paragraph size="14px" bold="600">
                              {inventoryDetail.saleunit != "" &&
                              inventoryDetail.saleunit != null
                                ? inventoryDetail.saleunit
                                : "-"}
                            </Paragraph>
                          </Grid>
                        </Grid>
                      </Grid>
                      {/* <Grid item xs={12} sm={12} md={4}>
                                                {productImage !== "" &&
                                                    <div className={classes.theProductImg}>
                                                        <img src={productImage} />

                                                        <input
                                                            className="ori-fileinput"
                                                            type="file"
                                                            name="file"
                                                            multiple
                                                            style={{
                                                                width: "150px",
                                                                height: "150px",
                                                                opacity: 0,
                                                                top: "0",
                                                                right: "0",
                                                                position: "absolute"
                                                            }}
                                                            onChange={handleCaptureMultiple}
                                                        />
                                                    </div>
                                                }
                                                {productImage === "" &&
                                                    <input
                                                        className="ori-fileinput"
                                                        type="file"
                                                        name="file"
                                                        multiple
                                                        style={{
                                                            // opacity: 0,
                                                            // top: "0",
                                                            // position: "absolute"
                                                        }}
                                                        onChange={handleCaptureMultiple}
                                                    />
                                                }
                                                {productImage !== "" &&

                                                    <div
                                                        className={classes.theCustomActionBtnFill_}
                                                        onClick={() => handleSaveImage()}
                                                    >
                                                        <Paragraph margin="4px 0">Save</Paragraph>
                                                    </div>
                                                }
                                            </Grid> */}
                    </Grid>
                    <br />
                    <React.Fragment>
                      <div
                        style={{
                          borderBottom: "2px solid #707070",
                          padding: ".2rem 0",
                        }}
                      />
                      <br />

                      <Paragraph color="#000" bold="700" size="16px">
                        Product Images
                      </Paragraph>
                      <br />
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                          <div className={classes.theSlider}>
                            <Slider
                              dots={true}
                              speed={500}
                              slidesToShow={4}
                              slidesToScroll={4}
                              infinite={infiniteStatus}
                            >
                              {inventoryDetail.images.length != 0 &&
                                inventoryDetail.images.map((res) => (
                                  <div>
                                    <div className={classes.theImageBox}>
                                      <div className={classes.theIBImg}>
                                        <img src={res.image} />
                                      </div>
                                      <div
                                        className={classes.theRemove}
                                        onClick={() => handleDeleteImage(res)}
                                      >
                                        <Delete style={{ color: "#fff" }} />
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </Slider>
                          </div>
                          <br />
                          <input
                            className="ori-fileinput"
                            type="file"
                            name="file"
                            accept="image/png, image/jpg, image/jpeg"
                            multiple
                            style={
                              {
                                // opacity: 0,
                                // top: "0",
                                // position: "absolute"
                              }
                            }
                            onChange={handleCaptureMultiple}
                          />

                          {/* {productImage !== "" &&
    <div className={classes.theProductImg}>
        <img src={productImage} />

        <input
            className="ori-fileinput"
            type="file"
            name="file"
            multiple
            style={{
                width: "150px",
                height: "150px",
                opacity: 0,
                top: "0",
                right: "0",
                position: "absolute"
            }}
            onChange={handleCaptureMultiple}
        />
    </div>
}
{productImage === "" &&
    <input
        className="ori-fileinput"
        type="file"
        name="file"
        multiple
        style={{
            // opacity: 0,
            // top: "0",
            // position: "absolute"
        }}
        onChange={handleCaptureMultiple}
    />
}
{productImage !== "" &&

    <div
        className={classes.theCustomActionBtnFill_}
        onClick={() => handleSaveImage()}
    >
        <Paragraph margin="4px 0">Save</Paragraph>
    </div>
} */}
                        </Grid>
                      </Grid>
                      <br />
                    </React.Fragment>
                    <div
                      style={{
                        borderBottom: "2px solid #707070",
                        padding: ".2rem 0",
                      }}
                    />
                    <br />
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12} md={12}>
                        <Card className={classes.theCard}>
                          <Paragraph color="#1A5386" bold="700" size="16px">
                            Product Variant
                          </Paragraph>
                          <br />
                          <div
                            className={classes.theWx}
                            style={{ margin: "0 20px 0 0" }}
                          >
                            <FormInputNoLabel
                              placeholder="Search"
                              border="1px solid #d7d7d7"
                              br="6px"
                              onChange={handleSearch}
                              value={searchKey}
                            />
                          </div>
                          <br />
                          <TableContainer>
                            <Table>
                              <TableHead style={{ backgroundColor: "#1A5386" }}>
                                <TableRow>
                                  <TableCell
                                    style={{ borderRadius: "10px 0 0 10px" }}
                                    className={classes.theHeadTitle}
                                  >
                                    Item Name
                                  </TableCell>
                                  {/* <TableCell className={classes.theHeadTitle}>
                                                                        Item Name
                                                                    </TableCell> */}
                                  <TableCell className={classes.theHeadTitle}>
                                    Size
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Color
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Gender
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Quantity Available
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Sale Unit
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Status
                                  </TableCell>

                                  <TableCell className={classes.theHeadTitle}>
                                    Images
                                  </TableCell>
                                  <TableCell
                                    style={{ borderRadius: "0 10px 10px 0" }}
                                    className={classes.theHeadTitle}
                                  >
                                    Price
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {filteredRows.map((item, index) => (
                                  <TableRow>
                                    <a
                                      style={{ display: "contents" }}
                                      // href={`../pickingorderdetail/${item.receive_id}`}
                                    >
                                      {/* <TableCell
                                                                                       style={{ width: "5%" }}
                                                                                   ><Checkbox
                                                                                           sx={{
                                                                                               color: "#1A5386",
                                                                                               '&.Mui-checked': {
                                                                                                   color: "#1A5386",
                                                                                               },
                                                                                           }} /></TableCell> */}
                                      <TableCell style={{ width: "20%" }}>
                                        <div>
                                          {item.itemname != "" &&
                                          item.itemname != null
                                            ? item.itemname
                                            : "-"}
                                        </div>
                                        {item.displayname != "" &&
                                        item.displayname != null
                                          ? item.displayname
                                          : "-"}
                                      </TableCell>
                                      <TableCell style={{ width: "5%" }}>
                                        {item.size != "" && item.size != null
                                          ? item.size
                                          : "-"}
                                      </TableCell>
                                      <TableCell style={{ width: "5%" }}>
                                        {item.colorname != "" &&
                                        item.colorname != null
                                          ? item.colorname
                                          : "-"}
                                      </TableCell>
                                      <TableCell style={{ width: "5%" }}>
                                        {item.gender != "" &&
                                        item.gender != null
                                          ? item.gender
                                          : "-"}
                                      </TableCell>
                                      <TableCell style={{ width: "15%" }}>
                                        <div
                                          onClick={() =>
                                            getHoldingList(item.internalid)
                                          }
                                        >
                                          <Paragraph
                                            color="#C52626"
                                            textDecoration="underline"
                                          >
                                            On Hold: {item.hold_stock} &#62;
                                          </Paragraph>
                                        </div>
                                        <div>
                                          On Hand: {item.quantityonhand}
                                          {/* {item.quantityavailable - item.hold_stock} */}
                                        </div>
                                        <div>
                                          Free to use: {item.quantityavailable}
                                        </div>
                                        {/* {item.quantityavailable != "" && item.quantityavailable != null ? item.quantityavailable : "-"} */}
                                      </TableCell>
                                      <TableCell style={{ width: "5%" }}>
                                        {item.saleunit != "" &&
                                        item.saleunit != null
                                          ? item.saleunit
                                          : "-"}
                                      </TableCell>
                                      <TableCell style={{ width: "5%" }}>
                                        {item.inactive == 0 ? (
                                          <Paragraph color="#707070">
                                            Active
                                          </Paragraph>
                                        ) : (
                                          <Paragraph color="#C52626">
                                            Inactive
                                          </Paragraph>
                                        )}
                                      </TableCell>
                                      <TableCell
                                        style={{ width: "10%" }}
                                        className={classes.theUnderLineLabel}
                                        onClick={() =>
                                          handleOpenVariantImage(item)
                                        }
                                      >
                                        {/* {item.price.map((res) =>
                                                                                           <p>{res.pricelevel} - {res.currency} {res.price}</p>
                                                                                       )} */}
                                        View &#62;
                                      </TableCell>
                                      <TableCell
                                        style={{ width: "10%" }}
                                        className={classes.theUnderLineLabel}
                                        onClick={() => handleOpen(item)}
                                      >
                                        {/* {item.price.map((res) =>
                                                                                           <p>{res.pricelevel} - {res.currency} {res.price}</p>
                                                                                       )} */}
                                        View &#62;
                                      </TableCell>
                                    </a>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Card>
                        <br />
                        <br />
                      </Grid>
                    </Grid>
                    <br />
                    <br />
                  </div>

                  <Dialog
                    onClose={handleClose}
                    open={open}
                    fullWidth="true"
                    maxWidth="sm"
                  >
                    <DialogTitle>
                      <Paragraph color="#1A5386" bold="600" size="24px">
                        {priceData != null && priceData.displayname} Price List
                      </Paragraph>
                    </DialogTitle>
                    <DialogContent>
                      {priceData != null &&
                        priceData.price.map((res) => (
                          <Paragraph
                            color="#707070 "
                            bold="600"
                            size="16px"
                            margin="0 0 10px"
                          >
                            <span style={{ fontWeight: "normal" }}>
                              {res.pricelevel}
                            </span>{" "}
                            - {res.currency} {res.price}
                          </Paragraph>
                        ))}
                    </DialogContent>
                  </Dialog>

                  {selectedVariant != null && (
                    <Dialog
                      onClose={handleCloseVariantImage}
                      open={openVariantImg}
                      fullWidth="true"
                      maxWidth="xl"
                    >
                      <DialogTitle>
                        <Paragraph color="#1A5386" bold="600" size="24px">
                          {priceData != null && priceData.displayname} Product
                          Variant Image
                        </Paragraph>
                      </DialogTitle>
                      <DialogContent>
                        <br />
                        <div className={classes.theSliderVariant}>
                          <Slider
                            dots={true}
                            speed={500}
                            slidesToShow={4}
                            slidesToScroll={4}
                            infinite={infiniteStatus}
                          >
                            {selectedVariant.images.length != 0 &&
                              selectedVariant.images.map((res) => (
                                <div>
                                  <div className={classes.theImageBox}>
                                    <div className={classes.theIBImg}>
                                      <img src={res.image} />
                                    </div>
                                    <div
                                      className={classes.theRemove}
                                      onClick={() => handleDeleteImage(res)}
                                    >
                                      <Delete style={{ color: "#fff" }} />
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </Slider>
                        </div>
                        <br />
                      </DialogContent>
                    </Dialog>
                  )}

                  {holdingList != null && (
                    <Dialog
                      onClose={handleCloseHolding}
                      open={openHolding}
                      fullWidth="true"
                      maxWidth="lg"
                    >
                      <DialogTitle>
                        <Paragraph color="#1A5386" bold="600" size="24px">
                          {priceData != null && priceData.displayname} Holding
                          List
                        </Paragraph>
                      </DialogTitle>
                      <DialogContent>
                        <br />
                        <TableContainer style={{ maxHeight: 300 }}>
                          <Table>
                            <TableHead style={{ backgroundColor: "#1A5386" }}>
                              <TableRow>
                                <TableCell
                                  style={{
                                    borderRadius: "10px 0 0 10px",
                                  }}
                                  className={classes.theHeadTitle}
                                >
                                  Order Number
                                </TableCell>
                                {/* <TableCell className={classes.theHeadTitle}>
                                                                Order Number
                                                            </TableCell> */}
                                <TableCell className={classes.theHeadTitle}>
                                  Customer Name
                                </TableCell>
                                <TableCell className={classes.theHeadTitle}>
                                  Quantity
                                </TableCell>
                                {/* <TableCell className={classes.theHeadTitle}>
                                                                Deposit Amount
                                                            </TableCell>
                                                            <TableCell className={classes.theHeadTitle}>
                                                                Outstanding Amount
                                                            </TableCell> */}
                                {/* <TableCell className={classes.theHeadTitle}>
                                                                Amount
                                                            </TableCell> */}
                                <TableCell
                                  style={{ borderRadius: "0 10px 10px 0" }}
                                  className={classes.theHeadTitle}
                                >
                                  Status
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {holdingList.map((item, index) => {
                                if (searchKey && searchKey !== "") {
                                  if (
                                    item.itemname &&
                                    item.itemname
                                      .toUpperCase()
                                      .indexOf(searchKey.toUpperCase()) <= -1
                                  ) {
                                    return null; // Return null to indicate that this element should be skipped
                                  }
                                }
                                return (
                                  <TableRow>
                                    <a
                                      style={{ display: "contents" }}
                                      href={`../saledetail/${item.sales_order_id}`}
                                    >
                                      {/* <TableCell>
                                                                                    <Checkbox
                                                                                        sx={{
                                                                                            color: "#000",
                                                                                            '&.Mui-checked': {
                                                                                                color: "#000",
                                                                                            },
                                                                                        }} />
                                                                                </TableCell> */}
                                      <TableCell
                                        className={classes.theUnderLineLabel}
                                        onClick={() =>
                                          navigate(
                                            "/saledetail/" + item.sales_order_id
                                          )
                                        }
                                      >
                                        {item.sales_order_id != "" &&
                                        item.sales_order_id != null
                                          ? item.sales_order_id
                                          : "-"}
                                      </TableCell>
                                      <TableCell
                                        onClick={() =>
                                          navigate(
                                            "/saledetail/" + item.sales_order_id
                                          )
                                        }
                                      >
                                        {item.entityid != "" &&
                                        item.entityid != null
                                          ? item.entityid
                                          : "-"}
                                      </TableCell>
                                      <TableCell
                                        onClick={() =>
                                          navigate(
                                            "/saledetail/" + item.sales_order_id
                                          )
                                        }
                                      >
                                        {item.quantity}
                                      </TableCell>
                                      <TableCell
                                        onClick={() =>
                                          navigate(
                                            "/saledetail/" + item.sales_order_id
                                          )
                                        }
                                      >
                                        {item.status}
                                      </TableCell>
                                      {/* <TableCell
                                                                                    onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                                                                                >
                                                                                    {item.deposit_amount}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                                                                                >
                                                                                    {item.outstanding_amount}
                                                                                </TableCell> */}
                                      {/* <TableCell
                                                                                    onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                                                                                >
                                                                                    <div
                                                                                        style={{ color: "#1A5386" }}
                                                                                    >Final Amount: {item.final_amount}</div>
                                                                                    {item.deposit_amount != '0.00' &&
                                                                                        <React.Fragment>
                                                                                            <div
                                                                                                style={{
                                                                                                    fontSize: "12px",
                                                                                                    color: "#C52626",
                                                                                                }}
                                                                                            >Deposit Amount: {item.deposit_amount}</div>
                                                                                            <div
                                                                                                style={{
                                                                                                    fontSize: "12px",
                                                                                                    color: "#C52626",
                                                                                                }}
                                                                                            >Outstanding Amount: {item.outstanding_amount}</div>
                                                                                        </React.Fragment>
                                                                                    }
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                                                                                >
                                                                                    {item.created_date}
                                                                                </TableCell> */}
                                    </a>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        <br />
                      </DialogContent>
                    </Dialog>
                  )}
                </Section>
              }
            />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
